import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Login from '@/views/Login'
import Register from '@/components/login/Register'
import MainLogin from '@/components/login/Login'
import ResetPassowrd from '@/components/login/ResetPassword'
import EmailLogin from '@/components/login/EmailLogin'
import GoogleLogin from '@/components/login/GoogleLogin'
import FacebookLogin from '@/components/login/FacebookLogin'
import Report from '@/views/Report'
import Map from '@/views/Map'
import Profile from '@/views/Profile'
import Link from '@/views/Link'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    children: [
      {
        name: 'login-main',
        path: '/',
        component: MainLogin
      },
      {
        name: 'login-register',
        path: 'register',
        component: Register
      },
      {
        name: 'login-reset',
        path: 'reset',
        component: ResetPassowrd
      },
      {
        name: 'login-reset-token',
        path: 'reset/:token',
        component: ResetPassowrd,
        props: true
      },
      {
        name: 'login-email',
        path: 'email',
        component: EmailLogin
      },
      {
        name: 'login-google',
        path: 'google',
        component: GoogleLogin
      },
      {
        name: 'login-facebook',
        path: 'facebook',
        component: FacebookLogin
      }
    ]
  },
  {
    path: '/report',
    name: 'Report',
    component: Report
  },
  {
    path: '/map',
    name: 'Map',
    component: Map
  },
  {
    path: '/map/:section',
    name: 'MapSub',
    component: Map
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/link',
    name: 'Link',
    component: Link
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js